import type { PainPoint } from '../types/content'

export const painPoints: PainPoint[] = [
  {
    problem: 'Hours spent planning individual sessions',
    impact: 'Your free time disappears before practice even begins.',
  },
  {
    problem: 'Repeating the same drills because they’re familiar',
    impact: 'Athletes stop receiving enough progression and variety.',
  },
  {
    problem: 'Random exercises without a clear development pathway',
    impact: 'Training becomes busy instead of purposeful.',
  },
  {
    problem: 'Too many coaching cues and no correction system',
    impact: 'You see the error but don’t always have the right progression ready.',
  },
  {
    problem: 'Different event groups competing for your attention',
    impact: 'Planning becomes chaotic.',
  },
  {
    problem: 'Competition weeks built from scratch every time',
    impact: 'Fatigue and volume become harder to manage.',
  },
]
